<template>
  <div class="template_wrapper">
    <span class="template_title">
      <span style="color:red;vertical-align: top;" v-if="moduel.required==1&& type=='audit'">*</span>
      {{moduel.name}}
    </span>
    <el-select
      v-model="options"
      filterable
      default-first-option
      :filter-method="nameInput"
      @change="getUsername"
      @focus="focus_event"
      placeholder="请输入人员搜索"
    >
      <el-option
        v-for="(item,key) in user_list"
        v-if="users_in_user_add.indexOf(item.user_id) == -1"
        :key="key"
        :label="item.username"
        :value="item.user_id"
      ></el-option>
    </el-select>
    <!-- <span style="color:red;vertical-align: top;" v-if="moduel.required==1&& type!='audit'" >*</span> -->

    <div
      style="margin-top: 10px;word-wrap: nowrap;width:60%;padding:0 0 0 100px;"
      v-if="moduel.key_name=='flow_user_ids' && project_user_add.length > 0"
    >
      <!-- <span>流程:</span> -->
      <span v-for="(item,key) in project_user_add" style="margin-top: 10px">
        <img src="../assets/arrow.png" alt class="arrow" v-if="key>0" />
        <span class="userSelected">
          {{item.username}}
          <span class="user_del" @click="del_user(key)">
            <img src="../assets/del_icon.png" alt />
          </span>
        </span>
      </span>
    </div>

    <div
      style="margin-top: 10px;word-wrap: nowrap;width:60%;padding:0 0 0 100px;"
      v-if="moduel.key_name=='cc_user_ids' && project_user_add.length > 0"
    >
      <!-- <span>抄送人:</span> -->
      <span v-for="(item,key) in project_user_add" style="margin-top: 10px">
        <span class="userSelected">
          {{item.username}}
          <span class="user_del" @click="del_user(key)">
            <img src="../assets/del_icon.png" alt />
          </span>
        </span>
      </span>
    </div>
  </div>
</template>
<style scoped>
.demonstration {
  line-height: 30px;
}
.users .el-select {
  width: 80%;
}
.userSelected {
  text-align: center;
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
  border-radius: 3px;
  margin-right: 10px;
  background: #e1e1e1;
  display: inline-block;
  color: #333;
}
.arrow {
  vertical-align: middle;
  height: 20px;
  width: auto;
}
.user_del {
  display: inline-block;
}
.user_del img {
  height: auto;
  width: 18px;
  /* line-height: 18px; */
  /* border-radius: 30px; */
  /* background: #ccc; */
  /* color: #fff; */
  margin: 0 0 0 8px;
  cursor: pointer;
  vertical-align: middle;
}
</style>
<script>
// import store from '@/vuex/store.js';
export default {
  name: "selectObj",
  data() {
    return {
      options: [],
      keyword: "",
      user_list: [],
      ids: [],
      project_user_add: [],
      web_token: "",
      web_url: "",
      users_in_user_add: []
    };
  },
  // store,
  props: ["moduel", "projectData", "type"],
  methods: {
    nameInput: function(keyword) {
      this.user_list = [];
      // console.log(keyword.replace(/\s*/g, "").length);
      if (keyword.replace(/\s*/g, "").length == 0) {
        this.user_list = [];
        return;
      }
      // 获取人员列表
      this.$http
        .post(
          this.web_url + "/user_list",
          { web_token: this.web_token, keyword: keyword },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.user_list = res.data.data;
            // this.user_list = this.user_list.concat(list2);
          } else {
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //获取i项目人员名字
    getUsername() {
      // this.project_user_add = [];
      var _this = this;
      for (var i = 0; this.user_list.length > i; i++) {
        if (this.options == this.user_list[i].user_id) {
          this.users_in_user_add.push(this.user_list[i].user_id);
          var obj = {
            user_id: this.user_list[i].user_id,
            username: this.user_list[i].username
          };
          this.project_user_add.push(obj);
          break;
        }
      }
      this.options = "";
      this.$emit("input", this.project_user_add);
      this.$emit("listenToChildEvent");
      this.user_list = [];
    },
    // focus_event(keywords) {
    //   console.log(this.options);
    //   if (this.options.length == 0) {
    //     this.user_list = [];
    //   }
    // },
    del_user: function(key) {
      this.project_user_add.splice(key, 1);
      this.users_in_user_add.splice(key, 1);
      this.$emit("input", this.project_user_add);
      this.$emit("listenToChildEvent");
    },
    clear() {
      this.options = [];
      this.project_user_add = [];
    }
  },
  created() {
    this.web_token = sessionStorage.getItem("web_token");
    this.user_info = JSON.parse(sessionStorage.getItem("user_info"));
    this.web_url = sessionStorage.getItem("web_url");
    console.log(this.type);
    // this.nameInput('');
    // for(var i =0; this.user_list.length > i; i++){
    //     this.options.push( this.user_list[i].user_id)
    // }
    // this.$emit('input', this.options);
  },
  watch: {
    users: {
      handler(newName, oldName) {
        this.options = [];
        this.project_user_add = [];
      },
      immediate: true
    }
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/components/select_flow.vue